import React, {useState} from 'react';

const MARKERS = ['A', 'B', 'C', 'D'];

const WorkbookOptionsPhase = ({
  workbook,
  workbookState,
  onSubmit,
  onContinue,
  continueDisabled = false,
}) => {
  const [selected, setSelected] = useState(null);
  const wb = workbook;
  const submitted = workbookState.submitted;
  const submittedIdx = workbookState.selectedOption;

  const handleSelect = (idx) => {
    if (submitted) return;
    setSelected(idx);
  };

  const handleSubmit = () => {
    if (selected === null) return;
    onSubmit(selected);
  };

  const getOptionClass = (idx) => {
    if (!submitted) {
      return idx === selected ? 'lcv-option-selected' : '';
    }
    if (idx === submittedIdx) {
      const isCorrect = wb.options[idx] === wb.correctAnswer;
      return isCorrect ? 'lcv-option-correct' : 'lcv-option-incorrect';
    }
    if (wb.options[idx] === wb.correctAnswer) {
      return 'lcv-option-correct';
    }
    return '';
  };

  return (
    <div className="lcv-work-panel">
      <div className="lcv-work-badge">
        <span className="lcv-work-dot" />
        WORKBOOK REVIEW
      </div>

      <div className="lcv-check-question">{wb.exercise}</div>

      <div className="lcv-options">
        {wb.options.map((opt, idx) => (
          <button
            key={idx}
            className={`lcv-option ${getOptionClass(idx)}`}
            onClick={() => handleSelect(idx)}
            disabled={submitted}
          >
            <span className="lcv-option-marker">{MARKERS[idx]}</span>
            <span>{opt}</span>
          </button>
        ))}
      </div>

      {submitted && (
        <div className={`lcv-feedback ${wb.options[submittedIdx] === wb.correctAnswer ? 'lcv-fb-correct' : 'lcv-fb-incorrect'}`}>
          <span>{wb.options[submittedIdx] === wb.correctAnswer ? '✅' : '❌'}</span>
          <span>{wb.optionFeedback[submittedIdx]}</span>
        </div>
      )}

      {!submitted && (
        <button className="lcv-btn-primary lcv-btn-full" onClick={handleSubmit} disabled={selected === null}>
          That's my answer →
        </button>
      )}
      {submitted && (
        <button
          className="lcv-btn-primary lcv-btn-full"
          onClick={onContinue}
          disabled={continueDisabled}>
          Continue →
        </button>
      )}
    </div>
  );
};

export default WorkbookOptionsPhase;
